var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"help-button-vertical",on:{"click":_vm.openHelp}},[_vm._v("\n\t\tSupport\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }